import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-aa648f84"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "step-one"
};
var _hoisted_2 = {
  class: "one-top"
};
var _hoisted_3 = {
  class: "video-area"
};
var _hoisted_4 = {
  class: "video-status-box"
};
var _hoisted_5 = {
  key: 0,
  class: "video-status"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "camera-close"
  }, null, -1);
});
var _hoisted_7 = {
  key: 0,
  class: "status-txt"
};
var _hoisted_8 = {
  key: 1,
  class: "status-txt"
};
var _hoisted_9 = {
  class: "micro-status"
};
var _hoisted_10 = {
  key: 0,
  class: "status-txt"
};
var _hoisted_11 = {
  key: 1,
  class: "status-txt"
};
var _hoisted_12 = {
  key: 2,
  class: "status-txt"
};
var _hoisted_13 = {
  key: 3,
  class: "status-txt"
};
var _hoisted_14 = {
  class: "device-area"
};
var _hoisted_15 = {
  class: "device-list"
};
var _hoisted_16 = {
  class: "device-item"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "name"
  }, "浏览器", -1);
});
var _hoisted_18 = {
  key: 0,
  class: "txt"
};
var _hoisted_19 = {
  key: 1,
  class: "txt"
};
var _hoisted_20 = {
  class: "device-item"
};
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "name"
  }, "摄像头", -1);
});
var _hoisted_22 = {
  key: 0,
  class: "txt"
};
var _hoisted_23 = {
  key: 1,
  class: "txt"
};
var _hoisted_24 = {
  class: "device-item"
};
var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "name"
  }, "麦克风", -1);
});
var _hoisted_26 = {
  key: 0,
  class: "txt"
};
var _hoisted_27 = {
  key: 1,
  class: "txt"
};
var _hoisted_28 = /*#__PURE__*/_createStaticVNode("<div class=\"check-tips\" data-v-aa648f84><div class=\"tips-title\" data-v-aa648f84><span class=\"line\" data-v-aa648f84></span><span class=\"title\" data-v-aa648f84>注意事项</span><span class=\"line\" data-v-aa648f84></span></div><div class=\"row-tips\" data-v-aa648f84><div class=\"col-tips\" data-v-aa648f84><div class=\"col-title\" data-v-aa648f84>1. 浏览器提示您授权，请务必点击允许；</div><div class=\"col-img img1\" data-v-aa648f84></div></div><div class=\"col-tips\" data-v-aa648f84><div class=\"col-title\" data-v-aa648f84> 2. 左侧出现画面，且调试状态正常，则可进入下一步。 </div><div class=\"col-img img2\" data-v-aa648f84></div></div></div></div>", 1);
import { computed, watch, ref, onMounted } from 'vue';
import { ScreenMediaService } from '@/services/recordVideo/media.service';
import { RecordVideoService } from '@/services/recordVideo/recordVideo.service';
import { useService } from '@kaokei/use-vue-service';
import { debounce } from 'lodash-es';
import { downloadChrome } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var _this = this;
    var screenMediaService = useService(ScreenMediaService);
    var recordVideoService = useService(RecordVideoService);
    var DeviceState = computed(function () {
      return screenMediaService.DeviceState;
    });
    var microVideoRef = ref();
    var nextStepLoading = ref(false);
    var checkCamera = function () {
      screenMediaService.checkVideo();
    };
    var checkMicro = function () {
      screenMediaService.checkAudio();
    };
    var checkStart = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              nextStepLoading.value = true;
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3,, 4]);
              return [4 /*yield*/, screenMediaService.checkStartDevice()];
            case 2:
              _a.sent();
              nextStepLoading.value = false;
              return [3 /*break*/, 4];
            case 3:
              e_1 = _a.sent();
              nextStepLoading.value = false;
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    };
    var JudgeCheckSuccess = computed(function () {
      return DeviceState.value.camera.status === 'finish' && DeviceState.value.micro.status === 'finish';
    });
    var onNextStep = debounce(function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          if (DeviceState.value.hasClickChecked) {
            // 展示弹窗
            if (JudgeCheckSuccess.value) {
              recordVideoService.setShowAnswerArea(true);
              recordVideoService.setCheckSuccess(true);
              recordVideoService.goRecordModule();
              recordVideoService.guideMaskVisible = true;
              screenMediaService.initCheckState();
            } else {
              // screenMediaService.NoDeviceVisible = true;
            }
          } else {
            checkStart();
          }
          return [2 /*return*/];
        });
      });
    }, 240);
    var noAuthEntrance = function () {
      recordVideoService.showVideoUpload();
      screenMediaService.initCheckState();
      screenMediaService.dispose();
    };
    onMounted(function () {
      watch(function () {
        return screenMediaService.stream;
      }, function (newStream) {
        if (microVideoRef.value) {
          microVideoRef.value.srcObject = newStream;
        }
      }, {
        immediate: true
      });
    });
    return function (_ctx, _cache) {
      var _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("video", {
        class: "video-box",
        ref: function (_value, _refs) {
          _refs['microVideoRef'] = _value;
          microVideoRef.value = _value;
        },
        autoplay: "",
        playsinline: "",
        muted: ""
      }, null, 512), !_unref(screenMediaService).stream ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _unref(DeviceState).camera.status === 'wait' ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 当前未接入摄像头 ")) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(DeviceState).camera.txt), 1))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", {
        class: _normalizeClass(["micro-icon", [_unref(DeviceState).micro.status === 'finish' ? 'finish' : 'error']])
      }, null, 2), _unref(DeviceState).micro.status === 'process' ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 设备检测中... ")) : _unref(DeviceState).micro.status === 'error' ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(DeviceState).micro.txt), 1)) : _unref(DeviceState).micro.status === 'finish' ? (_openBlock(), _createElementBlock("div", _hoisted_12)) : (_openBlock(), _createElementBlock("div", _hoisted_13, "当前未接入麦克风"))])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("ul", _hoisted_15, [_createElementVNode("li", _hoisted_16, [_createElementVNode("span", {
        class: _normalizeClass(["status", ["status-".concat(_unref(DeviceState).browser.status)]])
      }, null, 2), _hoisted_17, _unref(DeviceState).browser.status === 'process' ? (_openBlock(), _createElementBlock("span", _hoisted_18, " 设备检测中... ")) : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(DeviceState).browser.txt), 1)), _unref(DeviceState).browser.status === 'error' ? (_openBlock(), _createElementBlock("span", {
        key: 2,
        class: "action",
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          return _unref(downloadChrome) && _unref(downloadChrome).apply(void 0, args);
        })
      }, " 下载谷歌浏览器 ")) : _createCommentVNode("", true)]), _createElementVNode("li", _hoisted_20, [_createElementVNode("span", {
        class: _normalizeClass(["status", ["status-".concat(_unref(DeviceState).camera.status)]])
      }, null, 2), _hoisted_21, _unref(DeviceState).camera.status === 'process' ? (_openBlock(), _createElementBlock("span", _hoisted_22, " 设备检测中... ")) : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(DeviceState).camera.txt), 1)), _unref(DeviceState).camera.status === 'error' ? (_openBlock(), _createElementBlock("span", {
        key: 2,
        class: "action",
        onClick: checkCamera
      }, " 开启权限 ")) : _createCommentVNode("", true)]), _createElementVNode("li", _hoisted_24, [_createElementVNode("span", {
        class: _normalizeClass(["status", ["status-".concat(_unref(DeviceState).micro.status)]])
      }, null, 2), _hoisted_25, _unref(DeviceState).micro.status === 'process' ? (_openBlock(), _createElementBlock("span", _hoisted_26, " 设备检测中... ")) : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(DeviceState).micro.txt), 1)), _unref(DeviceState).micro.status === 'error' ? (_openBlock(), _createElementBlock("span", {
        key: 2,
        class: "action",
        onClick: checkMicro
      }, " 开启权限 ")) : _createCommentVNode("", true)])]), _createVNode(_component_a_button, {
        type: "primary",
        class: "next-step",
        onClick: _unref(onNextStep),
        loading: nextStepLoading.value
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref(DeviceState).hasClickChecked ? '下一步' : '开始检测'), 1)];
        }),
        _: 1
      }, 8, ["onClick", "loading"]), _unref(DeviceState).hasClickChecked && !_unref(JudgeCheckSuccess) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "no-check-entry",
        onClick: noAuthEntrance
      }, " 直接上传讲解视频 ")) : _createCommentVNode("", true)])]), _hoisted_28]);
    };
  }
});